export const getCharWidth = (text: string) => {
  const canvasElement = document.createElement('canvas')
  const context = canvasElement.getContext('2d')

  return context?.measureText(text).width || 0
}
